export default {
  modalDiscountExtraValueItem: false,
  generatePrint: false,
  checkouts: [],
  checkoutPosted: [],
  satTransmitter: [],
  discount: {
    valueDiscount: 0,
    percentDiscount: 0,
  },
  extraValue: {
    valueExtraValue: 0,
    percentExtraValue: 0,
  },
  discountItem: {
    valueDiscount: 0,
  },
  extraValueItem: {
    valueExtraValue: 0,
  },
  totalNota: {},
  total: 0,
};
